<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_TGLab_Field_Host')"
        prop="params.host"
        :hint="$t('Integrations_TGLab_Field_Host_Hint')"
      >
        <el-input
          v-model="model.params.host"
          :placeholder="$t('Integrations_TGLab_Field_Host')"
        />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_TGLab_Field_FranchiseID')"
        prop="params.franchiseID"
        :hint="$t('Integrations_TGLab_Field_FranchiseID_Hint')"
      >
        <el-input
          v-model="model.params.franchiseID"
          :placeholder="$t('Integrations_TGLab_Field_FranchiseID')"
        />
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'TGLabSettings',
  components: {
    FormSection,
    RestFormItem
  },
  data() {
    return {
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          host: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          franchiseID: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          }
        }
      }
    }
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/tglab/TGLabSettings.vue